import { render, staticRenderFns } from "./TypeSupplier.vue?vue&type=template&id=1b97347d&"
import script from "./TypeSupplier.vue?vue&type=script&lang=js&"
export * from "./TypeSupplier.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports